/**
 * This file provides lists of all possible Activity Log filters as well as some filter options.
 * These should eventually be provided by an API endpoint rather than being hard-coded in this file.
 */
import { eventFields } from 'client/Insights/ActivityLog/constants/EventMetadata';

export default {
  // These filters are not presented initially, but may be added by the admin.
  optionalFilters: [
    eventFields.applicationName,
    eventFields.applicationSsoUrl,
    eventFields.applicationSsoType,
    eventFields.associationFromName,
    eventFields.associationFromType,
    eventFields.associationToName,
    eventFields.associationToType,
    eventFields.associationOperation,
    eventFields.attributes,
    eventFields.authIdp,
    eventFields.authMechanism,
    eventFields.authMethod,
    eventFields.authType,
    eventFields.clientIp,
    eventFields.correlationId,
    eventFields.correlationType,
    eventFields.deref,
    eventFields.deviceGroup,
    eventFields.dn,
    eventFields.eapType,
    eventFields.errorChainErrorCode,
    eventFields.errorChainErrorDomain,
    eventFields.errorCode,
    eventFields.eventId,
    eventFields.filter,
    eventFields.geoipContinentCode,
    eventFields.geoipCountryCode,
    eventFields.geoipRegionCode,
    eventFields.geoipRegionName,
    eventFields.geoipTimezone,
    eventFields.geoipSourceContinentCode,
    eventFields.geoipSourceCountryCode,
    eventFields.geoipSourceRegionCode,
    eventFields.geoipSourceRegionName,
    eventFields.geoipSourceTimezone,
    eventFields.idpInitiated,
    eventFields.initiatedByEmail,
    eventFields.initiatedByType,
    eventFields.initiatedByUsername,
    eventFields.mdmDeviceId,
    eventFields.mfa,
    eventFields.mfaType,
    eventFields.mfaState,
    eventFields.numResults,
    eventFields.outerEapType,
    eventFields.outerUsername,
    eventFields.processName,
    eventFields.provider,
    eventFields.radiusCertificateAuthorityKeyId,
    eventFields.radiusCertificateUserIdLocation,
    eventFields.radiusCertificateIssuer,
    eventFields.radiusCertificateSerialNumber,
    eventFields.radiusPasswordEnabled,
    eventFields.radiusUserCertsEnabled,
    eventFields.requestType,
    eventFields.resourceEmail,
    eventFields.resourceHostname,
    eventFields.resourceName,
    eventFields.resourceType,
    eventFields.resourceUsername,
    eventFields.scope,
    eventFields.sourceIp,
    eventFields.startTls,
    eventFields.status,
    eventFields.success,
    eventFields.systemHostname,
    eventFields.systemOsFamily,
    eventFields.tlsEstablished,
    eventFields.userIdType,
    eventFields.username,
    eventFields.windowsElevated,
    eventFields.windowsLogonType,
  ],

  // These filters are presented by default and are not removable
  primaryFilters: [
    eventFields.service,
    eventFields.eventType,
    eventFields.user,
    eventFields.system,
  ],

  services: [
    { name: 'Directory', value: 'directory' },
    { name: 'LDAP', value: 'ldap' },
    { name: 'MDM', value: 'mdm' },
    { name: 'Password Manager', value: 'password_manager' },
    { name: 'RADIUS', value: 'radius' },
    { name: 'SSO', value: 'sso' },
    { name: 'Software', value: 'software' },
    { name: 'Systems', value: 'systems' },
  ],
};
